<div class="min-h-screen flex flex-col">
  <app-header class="fixed top-0 left-0 right-0 z-10"></app-header>
  <div class="flex-grow mt-20 overflow-y-auto">
    <app-message-wait4sign-alert
      *ngIf="showMessages"
      [showMessage]="showMessages"></app-message-wait4sign-alert>
    <router-outlet></router-outlet>
  </div>
  <app-footer class="z-10"></app-footer>
  <p-toast></p-toast>
  <app-popup-dialog
    *ngIf="showAdvisorSessionExpiredDialog"
    [visibleDialog]="showAdvisorSessionExpiredDialog"
    [saveMessage]="advisorSessionExpiredMessage"
    [acceptLabel]="'common.ok' | translate"
    [showRejectButton]="false"
    (dialogEmitter)="onAdvisorSessionExpiredConfirm()">
  </app-popup-dialog>
  <app-contact-phone *ngIf="shouldShowContactPhone()"></app-contact-phone>
</div>
